import Player from '@vimeo/player'

export default class EmbedVideo {
    constructor () {
        this.videos = document.querySelectorAll('.embed')
        this.inlineCta = document.querySelectorAll('.cta-play .link-cta')

        if (!this.videos)
            return

        this.videos.forEach(video => this.setup(video))
        this.inlineCta.forEach(cta => this.setupLinks(cta))
    }

    setup (el) {
        const iframe = el.querySelector('iframe')
        const thumbnail = el.querySelector('.embed-thumbnail')
        const playBtn = el.querySelector('.embed-thumbnail__play')
        const vimeo = iframe && iframe.src.includes('vimeo')

        if (!vimeo || !playBtn)
            return

        const videoPlayer = new Player(iframe)

        playBtn.addEventListener('click', () => {
            videoPlayer.play()
            thumbnail.classList.add('d-none')
        })
    }

    setupLinks (el) {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            this.videos[0].querySelector('.embed-thumbnail__play').click()
            window.scrollTo(0, this.videos[0].offsetTop - 120, { behavior: 'smooth' })
        })
    }
}
